import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CaqRequestService } from '../caq-request/caq-request.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NovasSalasEdicaoCsvService {
  private readonly urlBase = `${environment.apiUrl}/simulador/memoria-calculo/csv/modo-edicao/novas-salas`;

  constructor(private req: CaqRequestService) {}

  async exportarComBody(body: any): Promise<Blob> {
    return await firstValueFrom(this.req.postBlob(this.urlBase, body));
  }
}

